import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useHistory from "routing/useHistory";
import ArchiveIndexSet from "archive/components/ArchiveIndexSet/ArchiveIndexSet";
import { Row, Col, Button, ButtonToolbar } from "components/bootstrap";
import { ConfirmDialog, DocumentTitle, IfPermitted, PageHeader } from "components/common";
import IndicesPageNavigation from "components/indices/IndicesPageNavigation";
import DocsHelper from "util/DocsHelper";
import ArchiveRoutes from "archive/Routes";
import useArchiveIndexSetRangesMutation from "archive/hooks/useArchiveIndexRangesMutation";
const ArchiveIndexSetPage = () => {
  const { t } = useTranslation("enterprise_archive");
  const [showConfirmRecalculateDialog, setShowConfirmRecalculateDialog] = useState(false);
  const { push } = useHistory();
  const { rebuildArchiveIndexSetRangesMutation } = useArchiveIndexSetRangesMutation();
  const handleRecalculate = () => {
    setShowConfirmRecalculateDialog(true);
  };
  const recalculateRanges = () => {
    rebuildArchiveIndexSetRangesMutation().then(() => {
      setShowConfirmRecalculateDialog(false);
    });
  };
  const cancelRecalculate = () => {
    setShowConfirmRecalculateDialog(false);
  };
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("archive_index_set_page.document_title") }, /* @__PURE__ */ React.createElement(IndicesPageNavigation, null), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: t("archive_index_set_page.page_title"),
      documentationLink: {
        title: t("archive_index_set_page.documentation_link_title"),
        path: DocsHelper.PAGES.INDEX_MODEL
      },
      topActions: /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: ["indexsets:edit"] }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: () => push(ArchiveRoutes.INDEX_SET.CONFIGURATION) }, t("archive_index_set_page.edit_index_set"))), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: ["indexranges:rebuild"] }, /* @__PURE__ */ React.createElement(Button, { onClick: handleRecalculate }, t("archive_index_set_page.recalculate_index_ranges"))))
    }
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(ArchiveIndexSet, null)))), showConfirmRecalculateDialog && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: showConfirmRecalculateDialog,
      title: t("archive_index_set_page.confirm_recalculate_title"),
      onCancel: cancelRecalculate,
      onConfirm: recalculateRanges
    },
    /* @__PURE__ */ React.createElement("p", null, t("archive_index_set_page.confirm_recalculate_text"))
  ));
};
export default ArchiveIndexSetPage;
